import * as React from 'react';
import { filterIcon } from '@progress/kendo-svg-icons';
import {
  DropDownButton,
  DropDownButtonItemClickEvent
} from '@progress/kendo-react-buttons';
import KendoReactDatePicker from '@Shared.Angular/kendo.react/KendoReactDatePicker';
import {
  DatePickerProps,
} from '@progress/kendo-react-dateinputs';

type Props = Omit<DatePickerProps, 'onChange'> & {
  onChange?: (args: {
    value: Date | null;
    operator: string;
    syntheticEvent: React.SyntheticEvent | null;
  }) => void;
};

interface OperatorOption {
  text: string;
  value: string;
}

export const DateFilter: React.FC<Props> = (props) => {
  const { value, onChange } = props;
  const [dateValue, setDateValue] = React.useState<Date | null>(value ?? null);
  const [currentOperator, setCurrentOperator] = React.useState<string>('gte');

  const operatorOptions: OperatorOption[] = [
    { text: 'is after or equal to', value: 'gte' },
    { text: 'is before or equal to', value: 'lte' }
  ];

  const handleOperatorChange = (event: DropDownButtonItemClickEvent) => {
    const newOperator = event.item.value;
    setCurrentOperator(newOperator);
    onChange?.({
      value: dateValue,
      operator: newOperator,
      syntheticEvent: null
    });
  };

  return (
    <div className="k-filtercell date-filter">
      <div className="k-filtercell-wrapper">
        <KendoReactDatePicker
          value={dateValue}
          format={props.format ?? 'dd/MM/yyyy'}
          placeholder={props.placeholder ?? 'Select date'}
          title={dateValue ? dateValue.toLocaleDateString() : 'Select date'}
          onChange={(e) =>
            onChange?.({
              value: e.value ?? null,
              operator: currentOperator,
              syntheticEvent: e.syntheticEvent
            })
          }
        ></KendoReactDatePicker>
        <div className="date-filter-menu" title="Select filter type">
          <DropDownButton
            items={operatorOptions}
            text=""
            svgIcon={filterIcon}
            textField="text"
            onItemClick={handleOperatorChange}
            popupSettings={{ animate: false }}
            fillMode="flat"
          />
        </div>
        <div className="k-filtercell-operator">
          <button
            className={
              'k-button k-button-icon k-clear-button-visible' +
              (dateValue ? '' : ' k-state-disabled')
            }
            title="Clear"
            onClick={(e) => {
              e.preventDefault();
              setDateValue(null);
              onChange?.({
                value: null,
                operator: '',
                syntheticEvent: null
              });
            }}
          >
            <span className="k-icon k-i-filter-clear"></span>
          </button>
        </div>
      </div>
    </div>
  );
};
